import React from 'react';
interface PersonPhotoProps {
  src?: string;
  name: string;
  size?: number;
  rounded?: 'full' | 'md';
  className?: string;
}
export function PersonPhoto({
  src,
  name,
  size = 40,
  rounded = 'full',
  className = ''
}: PersonPhotoProps) {
  const r = rounded === 'full' ? 'rounded-full' : 'rounded-md';
  const initial = name.replace('মোঃ ', '').replace('মোসাঃ ', '').trim().charAt(0);
  if (src) {
    return <img src={src} alt={name} style={{
      width: size,
      height: size
    }} className={`${r} shrink-0 border border-border object-cover ${className}`} data-id="element-739" data-mp="p8tnao8gkl7f" />;
  }
  return <span style={{
    width: size,
    height: size,
    fontSize: size * 0.4
  }} className={`${r} flex shrink-0 items-center justify-center border border-navy-100 bg-navy-50 font-semibold text-navy-700 ${className}`} aria-label={name} data-id="element-740" data-mp="z552blzfnp5k">
      {initial}
    </span>;
}